import Vue from 'vue'
import notify from '~/plugins/notify/notify'

Vue.use(notify)
